"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useAnchorPosition = void 0;
var _react = require("react");
var _utils = require("../utils");
const useAnchorPosition = _ref => {
  let {
    subscribeToGenplanTransform,
    center,
    genplanSize
  } = _ref;
  const [anchorPosition, setAnchorPosition] = (0, _react.useState)((0, _utils.calculateAnchorPosition)(center, genplanSize));
  (0, _react.useEffect)(() => {
    subscribeToGenplanTransform(transform => {
      const newPosition = (0, _utils.calculateAnchorPosition)(center, genplanSize, transform);
      setAnchorPosition(newPosition);
    });
  }, [center, genplanSize, subscribeToGenplanTransform]);
  return anchorPosition;
};
exports.useAnchorPosition = useAnchorPosition;